import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';

import { ProductDto, UserAccountRegDto } from 'src/app/core/dtos/dto';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { RegistrationManagementService } from 'src/app/core/services/registration-management.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { BrandEnum, RegStatusEnum, TestTypeEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-order-test-re-evaluation',
  templateUrl: './order-test-re-evaluation.component.html',
  styleUrls: ['./order-test-re-evaluation.component.scss']
})
export class OrderTestReEvaluationComponent implements OnInit, OnDestroy {

  @ViewChild('errorModal') errorModal: ModalComponent;
  brandId: BrandEnum;
  regId: number;
  registrationDetailsSubscription: Subscription;
  reEvaluationProductsSubscription: Subscription;
  addToCartSubscription: Subscription;
  reEvaluationOrderStatusSubscription: Subscription;
  reEvaluationProductsForm: FormGroup;
  testInfo: UserAccountRegDto;
  components: ProductDto[];
  currencyCode: string;
  //we can select all 4 components for celpip only
  allFourCELPIPComponentsSelectedId = 5000;
  allFourComponentsSelected: boolean;
  orderDate: Date;
  totalAmount = 0;
  productIds = [];
  modalBody: string;

  constructor(
    private configHelper: ConfigHelper,
    private activatedRoute: ActivatedRoute,
    private registrationService: RegistrationService,
    private registrationManagementService: RegistrationManagementService,
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private toastService: HotToastService,
  ) {
    this.regId = Number(this.activatedRoute.snapshot.params.regId);
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.reEvaluationProductsForm = this.fb.group({
      selectedProducts: this.fb.array([])
    });
    this.getRegistrationDetails();
    this.getReEvaluationProducts();
    this.getReEvaluationOrderStatus();
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  public get TestTypeEnum() {
    return TestTypeEnum;
  }

  getRegistrationDetails() {
    this.registrationDetailsSubscription = this.registrationService.getTestInfo(this.regId)
      .subscribe(
        (result) => {
          this.testInfo = result.content;
          if (result.content.isCancelledOrRefunded || result.content.regStatusEnum !== RegStatusEnum.ScorePublished) {
            this.redirectToMyAccount();
          }
          if (!result.content.canOrderReEvaluation) {
            this.modalBody = "Unable to proceed. Your test date is older than 6 months.";
            this.errorModal.open();
          }
        },
        () => {
          this.loadingService.hide();
          this.redirectToMyAccount();
        }
      );
  }

  getReEvaluationProducts() {
    this.loadingService.show();
    this.reEvaluationProductsSubscription = this.registrationManagementService.getReEvaluationProducts(this.regId)
      .subscribe(
        (result) => {
          this.components = result.content;
          if (result.content.length > 0) {
            this.currencyCode = this.components[0].currencyCode;
          }
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
          this.redirectToMyAccount();
        }
      );
  }

  getReEvaluationOrderStatus() {
    this.reEvaluationOrderStatusSubscription = this.registrationManagementService.getReEvaluationOrderStatus(this.regId)
      .subscribe((result => {
        if (result) {
          this.orderDate = result.content;
        }
      }));
  }

  redirectToMyAccount() {
    this.router.navigate(['my-account']);
  }

  addReEvaluationsToCart() {
    this.loadingService.show();
    if (this.productIds.length > 0) {
      this.addToCartSubscription = this.shoppingCartService.addItemsWithReg(this.productIds, this.regId)
        .subscribe(
          () => {
            this.loadingService.hide();
            this.router.navigate(['shopping-cart']);
          },
          () => {
            this.loadingService.hide();
            this.toastService.warning("An error with adding score re-evaluation to cart has occured.");
          }
        );
    }
  }

  onSelect(event) {
    const productId = Number(event.target.id);
    const productListPrice = Number(event.target.value);
    if (event.target.checked) {
      if (this.brandId === BrandEnum.CELPIP && productId === this.allFourCELPIPComponentsSelectedId) {
        this.allFourComponentsSelected = true;
        this.totalAmount = 0;
      }
      this.productIds.push(productId);
      this.totalAmount = this.totalAmount + productListPrice;
    } else {
      if (this.brandId === BrandEnum.CELPIP && productId === this.allFourCELPIPComponentsSelectedId) {
        this.allFourComponentsSelected = false;
        this.calculateTotalAmount(this.productIds, this.components);
      }
      const index = this.productIds.indexOf(productId);
      this.productIds.splice(index, 1);
      this.totalAmount = this.totalAmount - productListPrice;
    }
  }

  ngOnDestroy(): void {
    this.registrationDetailsSubscription?.unsubscribe();
    this.reEvaluationProductsSubscription?.unsubscribe();
    this.reEvaluationOrderStatusSubscription?.unsubscribe();
    this.addToCartSubscription?.unsubscribe();
  }

  calculateTotalAmount(productIds: number[], components: ProductDto[]) {
    this.totalAmount = 0;
    components.forEach(element => {
      if (productIds.includes(element.id)) {
        this.totalAmount += element.listPrice;
      }
    });
  }
}
